import { useEffect } from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandStore } from 'zustandGlobalStore'

export const useFacebookPixelInitialization = (): void => {
  const { leadId, facebookPixelIds } = useZustandStore(
    useShallow((state) => ({
      leadId: state.lead?.id,
      facebookPixelIds: state.lead?.config?.cohort?.facebookPixelIds,
    })),
  )

  useEffect(() => {
    facebookPixelIds?.forEach((facebookPixelId) => {
      window.fbq('init', facebookPixelId, { external_id: leadId })
    })
    window.fbq('track', 'PageView')
  }, [facebookPixelIds, leadId])
}
